module.exports = __webpack_public_path__ + "static/media/gobal-certificate.3c2d058a.webp";